import React from 'react';

export default function Navbar() {
    return (
        <nav className='text-center text-[#EDD2E0]'>
            <div className='items-center justify-center bg-[#7A52A3]  text-[30px] font-normal'>
            What's the Weather?
            </div>
        </nav>
    )
}